export default {
  // eslint-disable-next-line no-unused-vars
  client: (state, getters, rootState, rootGetters) => {
    return state;
  }
};
